import { styled } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    padding: 100px 25px;
    gap: 30px;

    a {
        color: rgba(255, 255, 255, 0.5);
        text-decoration: none;
        font-size: 16px;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.9px;
        transition: color 0.3s;

        &:hover {
            color: #fff;
        }
    }

    @media (max-width: 768px) {
        padding: 30px 20px;
        gap: 10px;

        a {
            transform: translateY(20px);
        }
    }
`;

export const Title = styled.div`
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -1.5px;

    @media (max-width: 768px) {
        font-size: 22px;
        letter-spacing: -1.1px;
    }
`;

export const Text = styled.div`
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: -0.9px;

    @media (max-width: 768px) {
        font-size: 16px;
        letter-spacing: -0.8px;
        margin-bottom: 20px;
    }
`;
